// extracted by mini-css-extract-plugin
export var dot = "_r0-2";
export var wave = "_r0-0";
export var waveSmall = "_r0-1";